import { Injectable } from '@angular/core';
import { ShipmentHeader } from 'src/app/models/shipment-header';
import { ShipmentQuery } from 'src/app/models/shipment-query';
import { TableExportService } from './table-export.service';
import { TableColumnService } from './table-column.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { selectShipmentsTableState } from '../../../store/shipments-table/shipments-table.state';
import { switchMap, take, tap } from 'rxjs/operators';
import { ShipmentHeaderService } from './shipment-header.service';
import { Observable } from 'rxjs';
import { ExportFormatEnum } from '../../../enum/export-format.enum';
import { interfaceExportProgress } from '../../../store/interface/interface.actions';

@Injectable({
    providedIn: 'root'
})
export class ShipmentTableExportService extends TableExportService<ShipmentHeader, ShipmentQuery> {

    constructor(private tableColumnService: TableColumnService, private store: Store<AppState>,
                private shipmentHeaderService: ShipmentHeaderService) {
        super();
    }

    public export(format: ExportFormatEnum): Observable<any> {
        let filename;
        switch (format) {
            case ExportFormatEnum.CSV:
                filename = 'shipments.csv';
                break;
            case ExportFormatEnum.XLS:
                filename = 'shipments.xls';
                break;
            case ExportFormatEnum.XLSX:
                filename = 'shipments.xlsx';
                break;
        }
        return this.store.select(selectShipmentsTableState).pipe(
            take(1),
            switchMap(state => this.compile(
                state.columns.map(c => this.tableColumnService.get(c)),
                this.shipmentHeaderService,
                state.query,
                (progress) => this.store.dispatch(interfaceExportProgress({ progress }))
            )),
            tap(table => this.produce(table, filename))
        );
    }
}
